import { concat } from '@/helpers/string';

import type { CompanyNeedAddress } from '@/modules/companyNeed/types/address';
import type { EvoliaAddress } from '@/types/address';

export const formattedAddress = (
	address: EvoliaAddress | undefined,
	options?: { separator?: string }
): string => {
	if (!address) return '';
	const { separator = ', ' } = options ?? {};
	const { name, street, zip, city, streetNumber, bis, complement } = address;
	const completeStreet = concat(
		[streetNumber, bis, street || name, complement],
		' '
	);
	const zipAndCity = concat([zip, city], ' ');
	return concat([completeStreet, zipAndCity], separator);
};

export const formattedCompanyNeedAddress = (
	address: CompanyNeedAddress | undefined,
	options?: { separator?: string }
): string => {
	if (!address) return '';
	const { separator = ', ' } = options ?? {};
	// biome-ignore lint/correctness/noUnusedVariables: Init Biome
	const { street, zipCode, city, department, region, complement } = address;
	const completeStreet = concat([street, complement], ' ');
	const zipAndCity = concat([zipCode, city], ' ');
	return concat([completeStreet, zipAndCity], separator);
};
